import React from "react";

// Packages
import { makeStyles } from "@material-ui/core";

// Icons
import { SplashIcon } from "src/icons/NewUX";

// Components
import { SplashSection } from "src/components";

type Props = {
  onClick: () => void;
};

const useStyles = makeStyles((theme) => ({
  projectLink: {
    color: theme.palette.primary.light,
    fontWeight: 700
  },
  root: {
    height: "calc(100vh - 64px - 254px)",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.grey[700]
  },
  icon: {
    height: 215,
    width: 215,
    marginRight: 140
  }
}));

const SplashSectionWrapper = (props: Props) => {
  const { onClick } = props || {};

  const classes = useStyles();

  return (
    <SplashSection
      gridContainerStyle={classes.root}
      gridIconStyle={classes.icon}
      button={{
        color: "primary",
        onClick,
        label: "+ NEW DATASET"
      }}
      titleSection={{
        title: "Start by Adding a Dataset",
        subtitleLines: ["Add a new one by clicking on the button below."]
      }}
      icon={<SplashIcon />}
    />
  );
};

export default SplashSectionWrapper;
